import React from 'react'
import { useParams } from 'react-router-dom'
import { MultiCompaniesPointDetails } from '../shared/MultiCompaniesPointDetails'
import { PointBreakdown } from './PointBreakdown'
import { useGetCnnPoint } from '../../api/cnn'

export const CnnPointsDetailPage = () => {
  const { customerId } = useParams()

  return (
    <>
      <MultiCompaniesPointDetails
        title='HT Connect Points'
        useGetPoint={useGetCnnPoint}
        customerId={customerId}
        backLink='ht-connect/points'
        hiddenColumns={['point', 'discount']}
        accountSummary={[
          { label: 'Company Name', id: 'companyName' },
          { label: 'Bonus Tier 2 Tickets', id: 'bonusT2Tickets' },
          {
            id: 'salesIds',
            label: 'Sales Ids',
            view: ({ salesIds = [] }) => salesIds.map((id) => <div key={id}>{id}</div>),
          },
          {
            id: 'pointBreakdown',
            label: 'Point Breakdown',
            view: ({ pointBreakdown }) => <PointBreakdown pointBreakdown={pointBreakdown} />,
          },
          { label: 'Earned Points', id: 'point' },
        ]}
      />
    </>
  )
}
